// Recherche des listes : chaque mot doit se trouver dans l'une des colonnes (ET entre les mots, OU entre les
// colonnes). ra-data-postgrest coupe la recherche en mots mais les met tous en OU, si bien qu'un mot de plus
// élargissait la liste au lieu de la resserrer. Le filtre est écrit ici en syntaxe PostgREST et passé tel quel
// (opérateur vide après « @ »), chaque valeur entre guillemets pour les virgules, parenthèses et points.

// Colonnes indexées pour la recherche des e-mails et téléphones (atomic-crm).
const SEARCH_COLUMN: Record<string, string> = {
  email: "email_fts",
  phone: "phone_fts",
};

const quoted = (value: string) =>
  `"${value.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;

export const textSearchFilter = (
  columns: string[],
  q: string,
): Record<string, string> => {
  const words = String(q).trim().split(/\s+/).filter(Boolean);
  if (!words.length) return {};
  const groups = words.map(
    (word) =>
      `or(${columns
        .map((c) => `${SEARCH_COLUMN[c] ?? c}.ilike.${quoted(`*${word}*`)}`)
        .join(",")})`,
  );
  return { "and@": `(${groups.join(",")})` };
};
